'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _expressInterceptor = require('express-interceptor');

var _expressInterceptor2 = _interopRequireDefault(_expressInterceptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * DfpMiddleware
 *
 * @param  {object} function(req - express request object
 * @param  {object} res -           express response object
 * @return {object} function used by express-interceptor
 */
var DfpMiddleware = function () {
  function DfpMiddleware() {
    _classCallCheck(this, DfpMiddleware);

    this.adScriptInjector = (0, _expressInterceptor2.default)(this.injector.bind(this));
  }

  _createClass(DfpMiddleware, [{
    key: 'injector',
    // eslint-disable-line no-invalid-this

    /**
     * injector - Express Interceptor used to inject Ad Script into the final page output
     *
     * @param  {type} req Express Request Object
     * @param  {type} res Express Response Object
     * @return {object} function used by express-interceptor
     */
    value: function injector(req, res) {
      var _this = this;

      return {

        /**
         * isInterceptable - function used to determine if a particular request
         * should be intercepted.  Only a Content-Type of text/html should be
         * modified by this intercept function.
         * @return {type}  description
         */
        isInterceptable: function isInterceptable() {
          return _this.isHtmlContentType(res.get('Content-Type'));
        },

        /**
         * intercept - description
         *
         * @param  {string} body - full response body
         * @param  {function} send function to return new html body after modification.
         * @return {void}
         */
        intercept: function intercept(body, send) {
          if (_this.isAdsDisabled(req.query)) {
            send(body);
          } else {
            var responseHtml = _this.injectScripts(body, res.locals.adService);

            send(responseHtml);
          }
        }
      };
    }

    /**
     * isHtmlContentType - Determines if a given mime-type is HTML
     *
     * @param  {String} contentType - mime-type of current request
     * @return {Boolean} - true/false if mime-type is html content.
     */

  }, {
    key: 'isHtmlContentType',
    value: function isHtmlContentType(contentType) {
      return (/text\/html/.test(contentType)
      );
    }
  }, {
    key: 'injectScripts',
    value: function injectScripts(body, adService) {
      var htmlWithHeaderScripts = this.injectScriptIntoHead(body, adService.renderAdScript());
      var responseHtml = this.injectScriptIntoBody(htmlWithHeaderScripts, adService.renderEndPageScript());

      return responseHtml;
    }
  }, {
    key: 'injectScriptBeforeClosingTag',
    value: function injectScriptBeforeClosingTag(body, closingTag, script) {
      var finalBody = body.replace(closingTag, '' + script + closingTag);

      return finalBody;
    }

    /**
     * injectScriptIntoHead - Injects a given script into the head of an html document
     *
     * @param  {String} body   Body HTML
     * @param  {String} script HTML to be injected just before the </head> tag.
     * @return {String} Final HTML containing the script injected into the HTML.
     */

  }, {
    key: 'injectScriptIntoHead',
    value: function injectScriptIntoHead(body, script) {
      return this.injectScriptBeforeClosingTag(body, '</head>', script);
    }

    /**
     * injectScriptIntoBody - Injects a given script into the end of the body of an html document
     *
     * @param  {String} body   Body HTML
     * @param  {String} script HTML to be injected just before the </body> tag.
     * @return {String} Final HTML containing the script injected into the HTML.
     */

  }, {
    key: 'injectScriptIntoBody',
    value: function injectScriptIntoBody(body, script) {
      return this.injectScriptBeforeClosingTag(body, '</body>', script);
    }

    /**
     * isAdsDisabled - Checks if ads should be disabled based on URL.  If Url contains debug=1 then true else false.
     *
     * @param  {String} params - parameters in url of request
     * @return {Boolean} Based on the Url returns true or false to show or hide ads.
     */

  }, {
    key: 'isAdsDisabled',
    value: function isAdsDisabled(params) {
      var result = false;

      if (typeof params !== 'undefined' && typeof params.debug !== 'undefined') {
        result = params.debug === '1' || params.debug === '4';
      }
      return result;
    }
  }]);

  return DfpMiddleware;
}();

/**
 * Exports class as a singleton
 */


exports.default = new DfpMiddleware();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/legacy-advertising/dist/Middleware/express/DfpMiddleware.js
// module id = 1526
// module chunks = 0